import { useEffect, useRef } from "react"

const MD_BREAKPOINT = 768

export const useCollapseOnMobile = ({ setCollapsed }) => {
  const setCollapsedRef = useRef(setCollapsed)

  useEffect(() => {
    setCollapsedRef.current = setCollapsed
  }, [setCollapsed])

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined
    }

    const isMobile = () => window.innerWidth < MD_BREAKPOINT
    let wasMobile = isMobile()

    if (wasMobile) {
      setCollapsedRef.current(true)
    }

    const collapseOnMobile = () => {
      const mobile = isMobile()
      if (mobile && !wasMobile) {
        setCollapsedRef.current(true)
      }
      wasMobile = mobile
    }

    window.addEventListener('resize', collapseOnMobile)

    return () => {
      window.removeEventListener('resize', collapseOnMobile)
    }
  }, [])
}
